import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";
import { yang, toiletPaper } from "@/images";

const getToiletPaperDialog = [
  new Dialog(
    "SONNY YANG : Ahh, my Roll of Toilet Paper. Success, thy name is Sonny Yang!",
    yang,
    require("@/audio/Pandemic-64-Sonny-MP3.mp3")
  ),
  new Dialog(
    "[Acquired 1 x LAST ROLL OF TOILET PAPER]",
    toiletPaper,
    require("@/audio/Found_Jingle.mp3")
  ),
];

export class DarethsBathroom extends Scene {
  async init() {
    this.title = "Dareth's Bathroom";
    this.description = "";
    this.audio = null;
    this.image = require("@/images/Dareths_Bathroom.png");
  }
  get options(): any[] {
    return [
      new Choice("Search sink area", () => {
        this.description =
          "SONNY YANG : Hmmm, not a bar of soap or bottle of sanitiser in sight. How odd.";
        this.audio = require("@/audio/Pandemic-63-Sonny-MP3.mp3");
      }),
      new Choice("Search by toilet", async () => {
        if (this.state.inventory.toiletPaper.has) {
          this.description =
            "SONNY YANG: I’ve already taken what’s rightfully mine.";
        } else {
          await this.dialogRunner(getToiletPaperDialog)
          this.state.inventory.toiletPaper.has = true;
          if (this.state.inventory.beans.has) {
            await this.navigate(scenes.ConfrontDareth());
          }
        }
      }),
      new Choice("Leave", async () => await this.navigate(scenes.DarethsUpstairs())),
    ];
  }
}

export default new DarethsBathroom();
